/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiARewindForwardIcon16Light } from './MediaUiARewindForwardIcon16Light';
import { MediaUiARewindForwardIcon16Regular } from './MediaUiARewindForwardIcon16Regular';
import { MediaUiARewindForwardIcon16Solid } from './MediaUiARewindForwardIcon16Solid';
import { MediaUiARewindForwardIcon20Light } from './MediaUiARewindForwardIcon20Light';
import { MediaUiARewindForwardIcon20Regular } from './MediaUiARewindForwardIcon20Regular';
import { MediaUiARewindForwardIcon20Solid } from './MediaUiARewindForwardIcon20Solid';
import { MediaUiARewindForwardIcon24Regular } from './MediaUiARewindForwardIcon24Regular';
import { MediaUiARewindForwardIcon24Solid } from './MediaUiARewindForwardIcon24Solid';
import { MediaUiARewindForwardIcon32Regular } from './MediaUiARewindForwardIcon32Regular';
import { MediaUiARewindForwardIcon64Regular } from './MediaUiARewindForwardIcon64Regular';
var sizes = {
    16: {
        light: MediaUiARewindForwardIcon16Light,
        regular: MediaUiARewindForwardIcon16Regular,
        solid: MediaUiARewindForwardIcon16Solid,
    },
    20: {
        light: MediaUiARewindForwardIcon20Light,
        regular: MediaUiARewindForwardIcon20Regular,
        solid: MediaUiARewindForwardIcon20Solid,
    },
    24: {
        regular: MediaUiARewindForwardIcon24Regular,
        solid: MediaUiARewindForwardIcon24Solid,
    },
    32: {
        regular: MediaUiARewindForwardIcon32Regular,
    },
    64: {
        regular: MediaUiARewindForwardIcon64Regular,
    },
};
export var MediaUiARewindForwardIcon = forwardRef('MediaUiARewindForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
